import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { FrontendReportForm } from "@partikelart/portal/shared-typing";
import * as Sentry from "@sentry/angular";
import { Table, TableModule } from "primeng/table";
import { DataExportService } from "../data-export.service";

@Component({
	selector: "partikelart-export-report-table",
	templateUrl: "./multi-export-report-table.component.html",
	styleUrls: ["./multi-export-report-table.component.scss"],
	standalone: true,
	imports: [CommonModule, TableModule, TranslatePipe],
})
export class MultiExportReportTableComponent implements OnInit, AfterViewInit {
	@ViewChild("dt") table!: Table;
	@Input() reports!: FrontendReportForm[];
	@Output() selectedReportsEvent = new EventEmitter<FrontendReportForm[]>();

	isOpen = false;
	editMode = false;
	createMode = false;
	deleteMode = false;
	previousRowValue = "";

	selectedReports: FrontendReportForm[] = [];
	tempReports: FrontendReportForm[] = [];
	constructor(
		translate: TranslateService,
		private exportService: DataExportService,
	) {}
	ngOnInit() {
		Sentry.addBreadcrumb({
			category: "export",
			message: "Reports loaded",
			level: "info",
			data: { count: this.reports?.length },
		});
		this.selectedReports = this.reports;
	}
	onSelectUpdate(event: any, select: boolean) {
		if (!this.tempReports) {
			this.tempReports = this.reports;
		}
		const analysisNo = event.data.Analysis_No;
		const reportId = this.tempReports.findIndex((report) => {
			return report.analysisNo === analysisNo;
		});
		this.tempReports[reportId].checked = select;
		this.exportService.setFinalReportsSelection(this.tempReports);
		this.selectedReportsEvent.emit(this.tempReports);
	}
	selectAllUpdate(event: { checked: any }) {
		if (!this.tempReports) {
			this.tempReports = this.reports;
		}
		this.tempReports = this.tempReports.map((report) => {
			report.checked = true;
			return report;
		});
		this.selectedReportsEvent.emit(this.tempReports);
	}
	onSort(event: any) {
		this.tempReports = this.reports;
		this.selectedReportsEvent.emit(this.tempReports);
	}
	ngAfterViewInit() {
		if (this.table != null) {
			this.table.resetScrollTop = function () {
				// Nothing?
			};
		}
	}
}
